import { addDays, endOfDay, startOfDay } from "date-fns";
import { useCallback, useState } from "react";
import { DateRangeType } from "shared/types";

export type NullableDateRange = {
  startDate?: Date | string | null;
  endDate?: Date | string | null;
};

const toDate = (value: Date | string | null | undefined, fallback: Date): Date => {
  const date = value ? new Date(value) : fallback;
  return isNaN(date.getTime()) ? fallback : date;
};

export default function useDateRangePicker(
  startDate: Date = startOfDay(new Date()),
  endDate: Date = addDays(endOfDay(new Date()), 2),
) {
  const [dateRange, setRange] = useState<DateRangeType>({ startDate, endDate });

  const setDateRange = useCallback(
    (values: NullableDateRange) =>
      setRange((previous) => ({
        startDate: toDate(values.startDate, previous.startDate),
        endDate: toDate(values.endDate, previous.endDate),
      })),
    [],
  );

  return { dateRange, setDateRange };
}
